import React from "react";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://tanweenarabic.com/">
        Tanweenarabic.com
      </Link>
    </Typography>
  );
}

export default Copyright;
